import type { ImageVariable } from '@carboncopyco/types';
import { TextCaption } from '@carboncopyco/ui';
import { useState } from 'react';
import type { ImageDetails, ImageInputProps } from '../ImageInput';
import { ImageSelectionBox } from '../ImageInput/ImageSelectionBox';
import { UploadImageButton } from '../UploadImageButton';
import { ChooseVariableButton } from './ChooseVariableButton';
import { DestinationInputField } from './DestinationInputField';

export interface DestinationSelectionProps
  extends Pick<ImageInputProps, 'autoFocus' | 'onFocus'> {
  onSelectedImage?: (details: ImageDetails) => void;
  onSelectedVariable?: (variable: ImageVariable) => void;
  variables?: ImageVariable[];
}

export const DestinationSelection = ({
  onSelectedImage,
  onSelectedVariable,
  autoFocus,
  onFocus,
  variables,
}: DestinationSelectionProps) => {
  const [uploadStatus, setUploadStatus] =
    useState<ImageInputProps['state']>('idle');

  return (
    <DestinationInputField
      error={
        uploadStatus === 'error' &&
        'Image files must be in jpg, jpeg, or png format, and not exceed 10MB.'
      }
    >
      <ImageSelectionBox
        state={uploadStatus}
        autoFocus={autoFocus}
        onFocus={onFocus}
      >
        <div className="flex flex-col items-center gap-1">
          <UploadImageButton
            onUploadLoading={() => setUploadStatus('loading')}
            onUploadError={() => setUploadStatus('error')}
            onUploadSuccess={onSelectedImage}
          />
          {variables && (
            <>
              <TextCaption label="Or" />
              <ChooseVariableButton
                variables={variables}
                onSelect={onSelectedVariable}
              />
            </>
          )}
        </div>
      </ImageSelectionBox>
    </DestinationInputField>
  );
};
